import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { GamesComponent } from './games/games.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { BannerComponent } from './banner/banner.component';
import { MobileNavbarComponent } from './navbar/mobile-navbar.component';


@NgModule({
  declarations: [
    SearchbarComponent,
    GamesComponent,
    BannerComponent,
    MobileNavbarComponent,
  ],
  imports: [
    CommonModule,
    PipesModule,
    FormsModule,
    IonicModule,
  ],
  exports:[
    SearchbarComponent,
    GamesComponent,
    BannerComponent,
    MobileNavbarComponent,
  ]
})
export class MobileModule { }
